import PlusIconWithoutCircle from "../../../assets/icons/PlusIconWithoutCircle"
import Modal from "../../molecules/Modal"
import style from "./index.module.scss"
import ModalCard from "./ModalCard"
import Input from "../../atoms/Input"
import SearchIcon from "../../../assets/icons/SearchIcon"
import { useEffect, useRef, useState } from "react"
import { fnCreateBoardFromModel, fnGetBoardsModels, fnSearchBoardsModels } from "../../../services/boards"
import ModalShowDetail from "./ModalShowDetail"
import { useParams } from "react-router-dom"
import RcmpButton from "../../atoms/Button"
import { toast } from "@stardust-ds/react"
import intl from "react-intl-universal"

export default function RcmpModalCreateNewBoard(props) {
  const {
    isOpen,
    onClose,
    fnCreateNoModel,
    fnHandleSelectModel,
    fnOpenShowDetail,
    fetchBoards,
  } = props
  const [selectedModel, setSelectedModel] = useState(null)
  const [models, setModels] = useState([])
  const { panelId } = useParams()
  const inputRef = useRef(null)

  const handleSearchModels = async () => {
    const value = inputRef.current?.value
    if (value.length === 0) {
      const response = await fnGetBoardsModels()
      if (response.data) {
        setModels(response.data.data)
        return
      }
    }
    if (!value || value.length < 3) {
      return
    }
    
    const response = await fnSearchBoardsModels(value)
    if (response.data) {
      setModels(response.data.data)
      return
    }
  }

  const handleSelectModel = (modelId) => {
    const model = models.find((m) => m.opmd_nid === modelId)
    fnHandleSelectModel(model)
    fnOpenShowDetail()
    //setSelectedModel(model)
  }

  const handleCreateBoard = async (modelId) => {
    try {
      await fnCreateBoardFromModel(panelId, modelId)
      await fetchBoards(1)
      onClose()
    } catch(e) {
      toast({
        type: "error",
        description: intl.get("board.create_board_error"),
      })
    } 
  }

  useEffect(() => {
    fnGetBoardsModels().then((response) => {
      if (response.data) {
        setModels(response.data.data)
        return
      }
    })
  }, [isOpen])

  

  return (
    <>
      <Modal isOpen={isOpen} size={"2xl"} onClose={onClose}>
        <Modal.Header onClose={onClose}>Criar Novo Quadro</Modal.Header>
        <Modal.Content size={"2xl"}>
          <div className={style.content}>
            <h3>Escolha um quadro já existente ou crie um novo!</h3>
            <div className={style.searchContainer}>
              <label htmlFor="search">Pesquisar Modelos</label>
              <div>
                <input
                  className={style.searchInput}
                  ref={inputRef}
                  type="text"
                  placeholder="Pesquise por nome"
                />
                <RcmpButton className={style.searchButton} onClick={handleSearchModels} liquid>
                  <SearchIcon fill="#FFF" />
                </RcmpButton>
              </div>
            </div>
            <div className={style.boardList}>
              <div className={style.startNewBtn} onClick={fnCreateNoModel}>
                <PlusIconWithoutCircle />
                <span>Começar do Zero</span>
              </div>
              {models.map((model) => (
                <ModalCard
                  key={model.opmd_nid}
                  opmd_cname={model.opmd_cname}
                  opmd_cimage={model.opmd_cimage}
                  opmd_nid={model.opmd_nid}
                  opmd_cdescription={model.opmd_cdescription}
                  fnShowDetail={() => handleSelectModel(model.opmd_nid)}
                  handleCreateBoard={() => handleCreateBoard(model.opmd_nid)}
                />
              ))}
            </div>
          </div>
        </Modal.Content>
        <Modal.Footer size={"2xl"}></Modal.Footer>
      </Modal>
    </>
  )
}
